import { dialogClasses, dialogContentClasses } from '@mui/material'
import { uiColors } from '~/common/styles/colors'
import { depth } from '~/common/styles/depths'

export const getModalBasePrimitives = (
  fullWidth: boolean,
  fullHeight: boolean,
  backgroundColor: string,
  isFullScreenMobileModal: boolean,
) => {
  return {
    [`& .${dialogClasses.paper}`]: {
      ...(fullWidth ? { width: '100%' } : { maxWidth: '75%', minWidth: '320px' }),
      maxHeight: fullHeight ? '100%' : '80%',
      boxShadow: depth[2],
      borderRadius: '4px',
      backgroundColor,
    },
    ...(isFullScreenMobileModal && {
      padding: '16px',
    }),
  }
}

export const getSearchModalBasePrimitives = (fullWidth: boolean) => {
  return {
    [`& .${dialogClasses.paper}`]: {
      ...(fullWidth ? { width: '100%' } : { maxWidth: '75%', minWidth: '320px' }),
      minHeight: '420px',
      maxHeight: '80%',
      boxShadow: '0 16px 100px rgb(0 0 0 / 20%)', // Adapted from 'cmdk' library to match design
      borderRadius: '4px',
      border: `1px solid ${uiColors.border.normal}`,
    },
  }
}

export const modalActionsPrimitives = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  alignItems: 'center',
  padding: '16px',
}

export const modalTitlePrimitives = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px',
  gap: '32px',
}

export const modalContentPrimitives = (showContentBorder: boolean, padContent: boolean) => {
  return {
    padding: padContent ? '16px' : '0px',
    ...(showContentBorder && {
      borderTop: `1px solid ${uiColors.border.normal}`,
      borderBottom: `1px solid ${uiColors.border.normal}`,
    }),
    [`& .${dialogContentClasses.root}`]: {
      padding: padContent ? '16px' : '0px',
    },
  }
}

export const searchModalContentPrimitives = (showContentBorder: boolean) => {
  return {
    padding: '0px',
    ...(showContentBorder && {
      borderTop: `1px solid ${uiColors.border.normal}`,
      borderBottom: `1px solid ${uiColors.border.normal}`,
    }),
  }
}

export const modalTitleTextPrimitives = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  height: '24px',
  textWrap: 'nowrap',
}
